var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 45,
    viewBox: "0 0 52 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA9\x94\xEC\x9D\xB8 \xEC\x8B\xAC\xEB\xB3\xBC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.71713 45.0001C2.89759 45.0001 2.0765 44.701 1.43411 44.0966C0.107745 42.8482 0.0553676 40.7696 1.3155 39.4556C9.25676 31.1793 9.25676 18.2147 1.3155 9.93836C0.0553676 8.62434 0.107745 6.54725 1.43411 5.29734C2.76048 4.04742 4.8571 4.10084 6.11877 5.41485C16.4956 16.2276 16.4956 33.1663 6.11877 43.9776C5.46714 44.6567 4.59368 44.9986 3.71713 44.9986V45.0001Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.7741 45.0005C46.8975 45.0005 46.0241 44.6586 45.3724 43.9795C34.9956 33.1667 34.9956 16.228 45.3724 5.41524C46.6326 4.10123 48.7307 4.04934 50.0571 5.29773C51.3835 6.54611 51.4358 8.62473 50.1757 9.93874C42.2329 18.215 42.2329 31.1797 50.1757 39.456C51.4358 40.77 51.3835 42.8471 50.0571 44.097C49.4162 44.7013 48.5952 45.0005 47.7741 45.0005Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.874 24.8715C18.3301 24.8715 12.3484 22.5502 8.62655 20.5769C6.91044 19.6673 6.26343 17.5505 7.1831 15.8504C8.10124 14.1503 10.2379 13.5093 11.954 14.4204C15.0289 16.0519 20.0124 17.9748 26.3038 17.8863C32.1053 17.8024 36.7175 16.0213 39.5675 14.541C41.2913 13.6451 43.4218 14.3044 44.3261 16.0122C45.2303 17.7199 44.5648 19.8306 42.841 20.7265C37.782 23.3545 32.0976 24.7875 26.407 24.87C26.2298 24.873 26.0527 24.8745 25.877 24.8745L25.874 24.8715Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3981 7.79862C20.0027 7.79862 21.3034 6.05284 21.3034 3.89931C21.3034 1.74578 20.0027 0 18.3981 0C16.7935 0 15.4927 1.74578 15.4927 3.89931C15.4927 6.05284 16.7935 7.79862 18.3981 7.79862Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.0929 7.79862C34.6975 7.79862 35.9983 6.05284 35.9983 3.89931C35.9983 1.74578 34.6975 0 33.0929 0C31.4883 0 30.1875 1.74578 30.1875 3.89931C30.1875 6.05284 31.4883 7.79862 33.0929 7.79862Z",
    fill: "#25569D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1159787f6723b95452be099b856e4b82.svg";
export { ForwardRef as ReactComponent };